/* eslint-disable func-names */
/* eslint-disable import/no-anonymous-default-export */

import { moduleConstants } from '../constants/moduleConstants';

const initialState = {
  requesting: false,
  requested: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case moduleConstants.GETALL_REQUEST:
      return {
        requesting: true,
        requested: true,
      };
    case moduleConstants.GETALL_SUCCESS:
      return {
        ...state,
        requesting: false,
        requested: true,
        data: action.modules[0].listModules,
      };
    case moduleConstants.GETALL_SUCCESS_BOTH_LEVELS:
      return {
        ...state,
        requesting: false,
        requested: true,
        data: [...action.modulesLV1[0].listModules, ...action.modulesLV2[0].listModules],
        dataLV1: action.modulesLV1[0].listModules,
        dataLV2: action.modulesLV2[0].listModules,
      };
    case moduleConstants.GETALL_FAILURE:
      return {
        requesting: false,
        requested: true,
      };

    case moduleConstants.UNLOAD_MODULES:
      return initialState;
    default:
      return state;
  }
}
